// getters
const controlaccesoturns = state => state.controlaccesoturns

export default {
  controlaccesoturns
}



// WEBPACK FOOTER //
// ./src/store/modules/controlacceso/turns/getters.js